import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { suite } from 'self-service-api/core/utilities/links';
import ProductInfoContainer from '../../components/common/ProductInfoContainer';
import WhyGoHubSpotSection from '../../components/free-tools-page/WhyGoHubSpotSection';
import { SUITE_STARTER_UPGRADE_PAGE } from '../../constants/ErrorBoundaryNames';
import { SCREENS, UPGRADE_PAGES } from '../../constants/tracking/Locations';
import ComparePlansLink from '../ComparePlansLink';
import { withErrorBoundary } from '../ErrorBoundary';
import UpgradeHeroBanner from '../UpgradeHeroBanner';
import FreeSuiteStarterFeatureTableContainer from '../feature-table/FreeSuiteStarterFeatureTableContainer';
import SuiteStarterFeatureTableContainer from '../feature-table/SuiteStarterFeatureTableContainer';
import LimitSection from '../limit-usage/LimitSection';
import { useMC0655Data } from '../../hooks/mc0655Hooks';
import { useIsInActiveTrial } from '../../hooks/useIsInActiveTrial';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuiteStarterUpgradePage = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  isFreePortal,
  upgradeSource
}) => {
  const {
    isInMC0655Variant,
    hasExperimentsFetchSucceeded
  } = useMC0655Data();
  const isInTrial = useIsInActiveTrial();
  useEffect(() => {
    getUsageTracker().setProperties({
      screen: SCREENS.UPGRADE_PAGE,
      subscreen: UPGRADE_PAGES.SUITE_STARTER
    });
    getUsageTracker().track('upgradesInteraction', {
      action: 'viewed upgrade page',
      upgradeSource,
      upgradeKey: upgradeConfig.upgradeKey,
      apiName: upgradePointApiName,
      pageType: UPGRADE_PAGES.SUITE_STARTER
    });
    // keep empty dependency array so not to repeat event and exposure log
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const renderFeatureTable = () => {
    if (isFreePortal) {
      return /*#__PURE__*/_jsx(FreeSuiteStarterFeatureTableContainer, {
        purchaseMotions: purchaseMotions,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
        upgradeConfig: upgradeConfig,
        upgradePointApiName: upgradePointApiName
      });
    }
    return /*#__PURE__*/_jsx(SuiteStarterFeatureTableContainer, {});
  };
  const isLimitSectionDataReady = isFreePortal !== undefined && isInTrial !== undefined && hasExperimentsFetchSucceeded !== undefined;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "suite-starter-upgrade-page",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SUITE_STARTER_UPGRADE_PAGE"
    }), /*#__PURE__*/_jsx(UpgradeHeroBanner, {
      upgradeConfig: upgradeConfig,
      upgradePointApiName: upgradePointApiName,
      purchaseMotions: purchaseMotions,
      handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
    }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      style: {
        margin: 'auto'
      },
      children: [/*#__PURE__*/_jsx(ComparePlansLink, {}), isLimitSectionDataReady && /*#__PURE__*/_jsx(LimitSection, {
        isFreePortal: isFreePortal,
        isInTrial: isInTrial,
        isInMC0655Variant: isInMC0655Variant
      }), renderFeatureTable(), /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
        selectedNavItem: "suite-starter"
      })]
    })]
  });
};
export default withErrorBoundary(SuiteStarterUpgradePage, {
  boundaryName: SUITE_STARTER_UPGRADE_PAGE,
  redirectCallback: suite
});